"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var lodash_1 = require("lodash");
var control_properties_1 = require("./model/control-properties");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var combineLatest_1 = require("rxjs/observable/combineLatest");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var Observable_1 = require("rxjs/Observable");
var idm_form_management_ui_1 = require("@synisys/idm-form-management-ui");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var material_1 = require("@angular/material");
var FormExportDialogComponent = /** @class */ (function () {
    function FormExportDialogComponent(dialogRef, http, kbService, currentLanguageProvider, applicationPropertiesService, formManagementService, messageService) {
        this.dialogRef = dialogRef;
        this.http = http;
        this.kbService = kbService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.applicationPropertiesService = applicationPropertiesService;
        this.formManagementService = formManagementService;
        this.messageService = messageService;
        this._destroy$ = new Subject_1.Subject();
        this.formServiceUrlKey = 'form-service-url';
    }
    FormExportDialogComponent.getConfig = function () {
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.height = 'auto';
        dialogConfig.width = '450px';
        return dialogConfig;
    };
    FormExportDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        var currentLanguageId$ = this.currentLanguageProvider.getCurrentLanguage().pipe(operators_1.map(function (language) { return language.getId(); }), operators_1.publishReplay(1), operators_1.refCount());
        currentLanguageId$.switchMap(function (languageId) {
            _this.currentLanguageId = languageId;
            var forms$ = _this.formManagementService.loadAll().takeUntil(_this._destroy$);
            var csvHeaderMessages$ = Observable_1.Observable.from(_this.messageService.getMessages(languageId, _this.csvHeaderMessageKeys()));
            return combineLatest_1.combineLatest(forms$, csvHeaderMessages$);
        }).takeUntil(this._destroy$).subscribe(function (_a) {
            var forms = _a[0], messages = _a[1];
            _this.forms = forms;
            _this.csvHeaderMessages = Array.from(messages.values()).join(',');
        });
    };
    FormExportDialogComponent.prototype.exportForm = function () {
        var _this = this;
        var formExportData = [];
        var metaFields$ = this.kbService.getMetaFields(this.selectedForm.categorySystemName);
        var metaCategories$ = this.kbService.getAllMetaCategories();
        combineLatest_1.combineLatest(metaFields$, metaCategories$, this.formServiceCall()).takeUntil(this._destroy$)
            .subscribe(function (_a) {
            var categoryMetaFields = _a[0], metaCategories = _a[1], formJson = _a[2];
            _this.categoryMetaFields = categoryMetaFields;
            _this.metaCategories = metaCategories;
            if (formJson['data']) {
                var form = JSON.parse(formJson['data']);
                var property_1 = JSON.parse(form['property']);
                var layout = JSON.parse(form['layout']);
                var content_1 = layout[_this.selectedForm.categorySystemName]['forms'][_this.selectedForm.systemName]['content'];
                if (content_1) {
                    var layoutRowCells = content_1['grid']['rows'].map(function (row) {
                        return {
                            rowId: row['id'],
                            cells: _this.rowProcessing(row, content_1['grid']['type'] === 'tabular')
                        };
                    });
                    var layoutCells = lodash_1.flattenDeep(layoutRowCells.map(function (rowCell) { return rowCell['cells']; }));
                    layoutCells.forEach(function (rawControlInfo) {
                        var controlProperties = new control_properties_1.ControlProperties();
                        controlProperties.categorySystemName = _this.selectedForm.categorySystemName;
                        controlProperties.formSystemName = _this.selectedForm.systemName;
                        controlProperties.tabName = rawControlInfo.tabName;
                        controlProperties.title = rawControlInfo.title;
                        controlProperties.cardTitle = rawControlInfo.fatherCellTitle;
                        controlProperties.dbTableName = _this.selectedForm.categorySystemName;
                        var systemName;
                        if (!lodash_1.isEmpty(rawControlInfo['control']['fields'])) {
                            if (rawControlInfo['control']['fields'].hasOwnProperty('field')) {
                                systemName = rawControlInfo['control']['fields']['field'];
                            }
                            else {
                                var systemNameKey = Object.keys(rawControlInfo['control']['fields'])[0];
                                systemName = rawControlInfo['control']['fields'][systemNameKey];
                            }
                        }
                        var categoryMetaField = _this.categoryMetaFields.find(function (metaField) { return systemName === metaField.getSystemName(); });
                        if (categoryMetaField) {
                            controlProperties.title = categoryMetaField.getDisplayNameMultilingual().getValue(_this.currentLanguageId);
                            controlProperties.dbColumnName = controlProperties.title; // TODO db column name must added to MetaField
                            if (!lodash_1.isNil(categoryMetaField.getCompoundCategorySystemName())) {
                                var compoundMetaCategory = Array.from(_this.metaCategories)
                                    .find(function (metaCategory) { return metaCategory.getSystemName() === categoryMetaField.getCompoundCategorySystemName(); });
                                controlProperties.compoundCategoryDisplayName = compoundMetaCategory.getDisplayNameMultilingual().getValue(_this.currentLanguageId);
                                // TODO compound category db table name must added to MetaCategory
                                controlProperties.compoundCategoryDbTableName = compoundMetaCategory.getDisplayNameMultilingual().getValue(_this.currentLanguageId);
                            }
                        }
                        var eachProperty = _this.findProperty(rawControlInfo['id'], property_1[controlProperties.categorySystemName][controlProperties.formSystemName]['cells']);
                        if (eachProperty.hasOwnProperty('controlProperties')) {
                            if (eachProperty['controlProperties'].hasOwnProperty('hint') && eachProperty['controlProperties']['hint']) {
                                controlProperties.hint = JSON.parse(eachProperty['controlProperties']['hint'])[_this.currentLanguageId];
                            }
                            if (eachProperty['controlProperties'].hasOwnProperty('maxLength')) {
                                controlProperties.maxLength = eachProperty['controlProperties']['maxLength'];
                            }
                            if (eachProperty['controlProperties'].hasOwnProperty('notes')) {
                                controlProperties.notes = eachProperty['controlProperties']['notes'];
                            }
                            if (eachProperty['controlProperties'].hasOwnProperty('tooltipSettings')) {
                                var tooltipSettings = JSON.parse(eachProperty['controlProperties']['tooltipSettings']);
                                if (tooltipSettings['isWithTooltip']) {
                                    var tooltipCaption = JSON.parse(tooltipSettings['caption']);
                                    var tooltipContent = JSON.parse(tooltipSettings['content']);
                                    controlProperties.tooltipContent = tooltipContent[_this.currentLanguageId];
                                    controlProperties.tooltipCaption = tooltipCaption[_this.currentLanguageId];
                                }
                            }
                        }
                        if (eachProperty.hasOwnProperty('cellProperties') &&
                            eachProperty['cellProperties'].hasOwnProperty('visibility') &&
                            !lodash_1.isEmpty(eachProperty['cellProperties']['visibility'])) {
                            controlProperties.conditional = 'YES';
                        }
                        formExportData.push(controlProperties);
                    });
                }
            }
            _this.downloadCSV(_this.convertToCSV(formExportData));
            _this.closeDialog();
        });
    };
    FormExportDialogComponent.prototype.formServiceCall = function () {
        var _this = this;
        return Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this.formServiceUrlKey))
            .switchMap(function (url) {
            return _this.http.get(url + "/forms/" + _this.selectedForm.id);
        });
    };
    FormExportDialogComponent.prototype.downloadCSV = function (csv) {
        var downloadLink = document.createElement("a");
        var blob = new Blob(["\ufeff", csv]);
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = "data.csv";
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };
    FormExportDialogComponent.prototype.convertToCSV = function (controlProperties) {
        var str = '';
        for (var i = 0; i < controlProperties.length; i++) {
            var line = '';
            for (var index in controlProperties[i]) {
                if (line !== '') {
                    line += ',';
                }
                line += controlProperties[i][index];
            }
            str += line + '\r\n';
        }
        return this.csvHeaderMessages + '\n' + str;
    };
    FormExportDialogComponent.prototype.csvHeaderMessageKeys = function () {
        return [
            'ejustice_export_form_category_system_name',
            'ejustice_export_form_system_name',
            'ejustice_export_form_card_title',
            'ejustice_export_form_tab_name',
            'ejustice_export_form_control_title',
            'ejustice_export_form_hint',
            'ejustice_export_form_max_length',
            'ejustice_export_form_note',
            'ejustice_export_form_tooltip_caption',
            'ejustice_export_form_tooltip_content',
            'ejustice_export_form_compound_category_display_name',
            'ejustice_export_form_compound_category_table_name',
            'ejustice_export_form_db_table_name',
            'ejustice_export_form_db_column_name',
            'ejustice_export_form_conditional'
        ];
    };
    FormExportDialogComponent.prototype.findProperty = function (rawControlInfoId, propertyCells) {
        return propertyCells.find(function (propertyCell) { return rawControlInfoId === propertyCell['id']; });
    };
    FormExportDialogComponent.prototype.rowProcessing = function (row, isTabular) {
        var _this = this;
        var tabName = isTabular ? this.extractTitle(row['title']) : 'N/A';
        return lodash_1.flattenDeep(row['cells'].map(function (cell) {
            if (!lodash_1.isNil(cell['control'])) {
                return {
                    title: _this.extractTitle(cell['title']),
                    control: cell['control'],
                    fatherCell: '',
                    tabName: tabName,
                    id: cell['id'],
                };
            }
            if (!lodash_1.isNil(cell['grid'])) {
                return _this.innerGridProcessing(cell['grid'], cell, tabName);
            }
        }));
    };
    FormExportDialogComponent.prototype.changeForm = function (formId) {
        this.selectedForm = this.forms.find(function (form) { return formId === form.id; });
    };
    FormExportDialogComponent.prototype.extractTitle = function (titleObj) {
        return (titleObj['title_msg'] && titleObj['title_src'] === 'msg') ? (titleObj['title_msg'])
            : (titleObj['custom_text'] && titleObj['title_src'] === 'custom') ? titleObj['custom_text'][this.currentLanguageId] : 'N/A';
    };
    FormExportDialogComponent.prototype.innerGridProcessing = function (grid, fatherCell, tabName) {
        var _this = this;
        return lodash_1.flattenDeep(grid['rows'].map(function (currRow) {
            return lodash_1.flattenDeep(currRow['cells'].map(function (cell) {
                if (!lodash_1.isNil(cell['control'])) {
                    return {
                        title: _this.extractTitle(cell['title']),
                        control: cell['control'],
                        fatherCellTitle: _this.extractTitle(fatherCell['title']),
                        id: cell['id'],
                        tabName: tabName
                    };
                }
                if (!lodash_1.isNil(cell['grid'])) {
                    return _this.innerGridProcessing(cell['grid'], cell, tabName);
                }
            }));
        }));
    };
    FormExportDialogComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next(true);
        this._destroy$.complete();
    };
    FormExportDialogComponent.prototype.closeDialog = function () {
        this.dialogRef.close();
    };
    FormExportDialogComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-form-export-dialog',
            template: require('./form-export-dialog.component.html'),
            styles: [require('./form-export-dialog.component.scss')]
        }),
        __metadata("design:paramtypes", [material_1.MatDialogRef,
            http_1.HttpClient, idm_kb_service_client_js_1.KbService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_form_management_ui_1.FormManagementService,
            idm_message_language_service_client_js_1.MessageService])
    ], FormExportDialogComponent);
    return FormExportDialogComponent;
}());
exports.FormExportDialogComponent = FormExportDialogComponent;
//# sourceMappingURL=form-export-dialog.component.js.map